var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchLower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 11C18.6866 11 19.0036 10.6858 18.965 10.3011C18.8046 8.70129 18.0967 7.19724 16.9497 6.05025C15.637 4.7375 13.8565 4 12 4C10.1435 4 8.36301 4.7375 7.05025 6.05025C5.90326 7.19724 5.19543 8.70129 5.03495 10.3011C4.99637 10.6858 5.3134 11 5.7 11V11C6.0866 11 6.39548 10.6854 6.44367 10.3018C6.59793 9.07402 7.15593 7.92447 8.0402 7.0402C9.09041 5.99 10.5148 5.4 12 5.4C13.4852 5.4 14.9096 5.99 15.9598 7.0402C16.8441 7.92447 17.4021 9.07402 17.5563 10.3018C17.6045 10.6854 17.9134 11 18.3 11V11Z",
    fill: "#97C9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 13C18.6866 13 19.0036 13.3142 18.965 13.6989C18.8046 15.2987 18.0967 16.8028 16.9497 17.9497C15.637 19.2625 13.8565 20 12 20C10.1435 20 8.36301 19.2625 7.05025 17.9497C5.90326 16.8028 5.19543 15.2987 5.03495 13.6989C4.99637 13.3142 5.3134 13 5.7 13V13C6.0866 13 6.39548 13.3146 6.44367 13.6982C6.59793 14.926 7.15593 16.0755 8.0402 16.9598C9.09041 18.01 10.5148 18.6 12 18.6C13.4852 18.6 14.9096 18.01 15.9598 16.9598C16.8441 16.0755 17.4021 14.926 17.5563 13.6982C17.6045 13.3146 17.9134 13 18.3 13V13Z",
    fill: "#185DD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchLower);
export default __webpack_public_path__ + "static/media/ArchLower.cacaae58c413584176a40cf74de93582.svg";
export { ForwardRef as ReactComponent };